import React, {Component} from 'react'
import PropTypes from 'prop-types'
import HistoryHead from "./HistoryHead"
import HistoryBody from "./HistoryBody"

class HistoryTable extends Component {
    render() {
        return (
            <div className='HistoryTable'>
                <table className="table">
                    <HistoryHead/>
                    <HistoryBody {...this.props}/>
                </table>
            </div>
        )
    }
}

HistoryTable.propTypes = {
    loading: PropTypes.bool,
    error: PropTypes.string,
    listHistories: PropTypes.array
}

export default HistoryTable